const BookingActionEnum = {
  WAITING_CHECK_IN: 1,
  CANCEL: 2,
  CHECKED_IN: 3,
  CHECK_OUT: 4
}
export default BookingActionEnum



// WEBPACK FOOTER //
// ./src/enum/bookingActionEnum.js